<script lang="ts" setup>
import type { StaticPageListItemDetails } from '~/types/StaticPageList';

const isShowModal = defineModel<boolean>({ default: false });
const specialOffersStore = useSpecialOffersStore();

const page = ref<StaticPageListItemDetails | null>(null);

async function getLoyaltyPage() {
  if (page.value) return;

  page.value = await specialOffersStore.getSpecialOffersItemBySlug('loyalty', true);
}

getLoyaltyPage();
</script>

<template>
  <BaseModal
    v-model="isShowModal"
    @close="isShowModal = false"
  >
    <StaticPageConstructorBlocks
      v-if="page"
      :blocks="page.constructorBlocks"
      class="my-5"
    />
  </BaseModal>
</template>
